// src/components/TokenSummaryCards.jsx

export default function TokenSummaryCards({ visits = [], treatmentEntries = [],  packagePayments = [], }) {
  const branchSummary = {};

  visits.forEach((v) => {
    const branch = v.branch_name
      ? v.branch_name.replace(/\s*branch\s*/i, "").trim()
      : "Unknown";

    const amount =
      v.consultation_payment_status === "TREATMENT"
        ? Number(v.treatment_amount || 0)
        : Number(v.consultation_fee || 0);

    if (!branchSummary[branch]) {
      branchSummary[branch] = {
        patients: new Set(),
        cash: 0,
        online: 0,
        total: 0,
      };
    }

   branchSummary[branch].patients.add(
  v.vpjc_id || v.patient_id
);

    if (v.payment_mode === "CASH") {
      branchSummary[branch].cash += amount;
    } else if (v.payment_mode === "ONLINE") {
      branchSummary[branch].online += amount;
    }

    branchSummary[branch].total += amount;
  });

  treatmentEntries.forEach((t) => {
    if (t.visit_id) return;
  const branch = t.branch_name
    ? t.branch_name.replace(/\s*branch\s*/i, "").trim()
    : "Unknown";

  const amount = Number(t.amount || 0);

  if (!branchSummary[branch]) {
    branchSummary[branch] = {
      patients: new Set(),
      cash: 0,
      online: 0,
      total: 0,
    };
  }

branchSummary[branch].patients.add(
  t.vpjc_id || t.patient_id
);

  if (t.payment_mode === "CASH") {
    branchSummary[branch].cash += amount;
  } else if (t.payment_mode === "ONLINE") {
    branchSummary[branch].online += amount;
  }

  branchSummary[branch].total += amount;
});

  packagePayments.forEach((p) => {
  const branch = p.branch_name
    ? p.branch_name.replace(/\s*branch\s*/i, "").trim()
    : "Unknown";

  const amount = Number(p.amount || 0);

  if (!branchSummary[branch]) {
    branchSummary[branch] = {
      patients: new Set(),
      cash: 0,
      online: 0,
      total: 0,
    };
  }

  branchSummary[branch].patients.add(
    p.vpjc_id || p.patient_id
  );

  if (p.payment_mode === "CASH") {
    branchSummary[branch].cash += amount;
  } else if (p.payment_mode === "ONLINE") {
    branchSummary[branch].online += amount;
  }

  branchSummary[branch].total += amount;
});

  const branches = Object.entries(branchSummary);

  const grandPatients = new Set();
  let grandCash = 0;
  let grandOnline = 0;
  let grandTotal = 0;

  branches.forEach(([_, data]) => {
    data.patients.forEach((id) => grandPatients.add(id));
    grandCash += data.cash;
    grandOnline += data.online;
    grandTotal += data.total;
  });

  return (
    <div className="bg-white rounded-xl p-4 shadow-md border border-gray-200">
      <h3 className="font-semibold text-[#204080] mb-3">
        Branch Summary
      </h3>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-center">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="py-2">Branch</th>
              <th>Total Patients</th>
              <th>Total Cash</th>
              <th>Total Online</th>
              <th>Total Amount</th>
            </tr>
          </thead>

          <tbody>
            {branches.map(([branch, data]) => (
              <tr key={branch} className="border-b">
                <td className="py-2 font-medium">{branch}</td>
                <td>{data.patients.size}</td>
                <td>₹{data.cash.toLocaleString("en-IN")}</td>
                <td>₹{data.online.toLocaleString("en-IN")}</td>
                <td className="font-semibold">
                  ₹{data.total.toLocaleString("en-IN")}
                </td>
              </tr>
            ))}

            <tr className="bg-blue-50 font-bold text-[#204080]">
              <td className="py-2">TOTAL</td>
              <td>{grandPatients.size}</td>
              <td>₹{grandCash.toLocaleString("en-IN")}</td>
              <td>₹{grandOnline.toLocaleString("en-IN")}</td>
              <td>₹{grandTotal.toLocaleString("en-IN")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}